import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from 'yoda-core-components/lib/components/Button';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import SuccessCheck from 'yoda-core-components/lib/assets/svg/SuccessCheck.svg';
import Alert from 'yoda-core-components/lib/assets/svg/Alert.svg';
import { isIosSafari } from 'yoda-core-components/lib/helpers/Utils/Utils';
import CouponUtilsHelper from '../CouponList/CouponUtilsHelper';
import CouponAppliedModal from '../CouponAppliedModal/CouponAppliedModal';
import ShowBarCode from '../ShowBarCode/ShowBarCode';
import {
    COUPON_APPLED_METHOD_SELECT_COUPON,
    couponErrorMessages,
    COUPON_REDEEMING_CHANNEL_IN_STORE,
    COUPON_REDEEMING_CHANNEL_ALL,
    COUPON_CATEGORY_ONLINE_ONLY,
    COUPON_CATEGORY_ALL,
    COUPON_CATEGORY_IN_STORE,
    IRIS_COUPON_EMPTYCART_LABEL,
} from '../../common/Constants';
import analyticsActions from '../../actions/AnalyticsAction';
import adjustmentActions from '../../actions/AdjustmentAction';
import * as styles from './CouponCard.css';
import CouponDetailsModalAction from '../../actions/CouponDetailsModalAction';
import { selectDeviceType } from '../../selectors/ContextSelector';

const cx = classNames.bind(styles);
let isFirstTime = true;
// 001 let couponInfoHeight = '';

// TODO :: This component will be upgraded by Checkout Team
export class CouponApply extends Component {
    static propTypes = {
        couponData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        actions: PropTypes.object,
        couponApplicationState: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
            PropTypes.number,
            PropTypes.string,
        ]),
        onApplyCouponCallBack: PropTypes.func,
        onRemoveCouponCallBack: PropTypes.func,
        removeCouponId: PropTypes.number,
        couponVariant: PropTypes.oneOf(['Small', 'Default']),
        onClosePanel: PropTypes.func,
        couponSlot: PropTypes.number,
        redeemingChannel: PropTypes.string,
        bagItemCount: PropTypes.number,
        featureFlags: PropTypes.object,
        displayCouponType: PropTypes.bool,
        enableCouponExposeBarcodes: PropTypes.bool,
        couponAnimation: PropTypes.bool,
        setApplyCouponRequest: PropTypes.func,
        couponDetailsModal: PropTypes.bool,
        deviceType: PropTypes.object,
        isCouponDrawer: PropTypes.bool,
    };

    static defaultProps = {
        couponData: [],
        actions: {},
        couponApplicationState: {},
        funnel: '',
        onApplyCouponCallBack: function onApplyCouponCallBack() {
            return null;
        },
        onRemoveCouponCallBack: function onRemoveCouponBack() {
            return null;
        },
        removeCouponId: 0,
        couponVariant: 'Default',
        onClosePanel: null,
        onApplyCoupon: null,
        couponSlot: 1,
        redeemingChannel: '',
        bagItemCount: 0,
        featureFlags: {},
        displayCouponType: false,
        enableCouponExposeBarcodes: false,
        couponAnimation: false,
        setApplyCouponRequest: () => {},
        couponDetailsModal: false,
        deviceType: {},
        isCouponDrawer: false,
    };

    constructor() {
        super();
        this.state = {
            removeCouponId: 0,
            showInfoMsg: false,
            isLoading: false,
        };
        this.onRemoveCoupon = this.onRemoveCoupon.bind(this);
        this.onApplyCoupon = this.onApplyCoupon.bind(this);
        this.showApplyRemoveSucess = this.showApplyRemoveSucess.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        /* istanbul ignore next */
        if (isFirstTime) {
            /* 001 const el = document.querySelector('[data-automation-id="at-coupon-info-layout"]') || {};
               couponInfoHeight = el.clientHeight + 50; */
            isFirstTime = false;
        }
    }

    onApplyCoupon = (featureFlags, promoCode, couponListId) => {
        const applyingToEmptyCart = featureFlags && featureFlags.Coupon_AllowApplyEmptyCart;

        if (this.props.bagItemCount > 0 || applyingToEmptyCart) {
            /* istanbul ignore else */
            if (this.props.onClosePanel) {
                this.props.onClosePanel();
            }

            // make sure details modal is hidden
            this.props.actions.openDetailsModal && this.props.actions.openDetailsModal(false);

            this.props.actions.applyAdjustment({
                code: this.props.couponData.content.promoCode.trim(),
                serialNumber: null,
                method: COUPON_APPLED_METHOD_SELECT_COUPON,
                slot: this.props.couponSlot,
                category: this.props.redeemingChannel,
                couponAnimation: this.props.couponAnimation,
                selectedCouponCode: promoCode,
            });
            this.props.setApplyCouponRequest(couponListId);
        } else {
            this.setState({
                showInfoMsg: true,
            });
            this.props.actions.triggerFormError([
                { errorDescription: couponErrorMessages.IRIS_COUPON_NO_CART_ITEMS },
            ]);
        }
    };

    onRemoveCoupon = (selectedCouponCode, couponListId) => {
        if (this.props.onClosePanel) {
            this.props.onClosePanel();
        }
        // /* istanbul ignore else */
        this.props.removeCouponId !== 0 &&
            this.setState({ removeCouponId: this.props.removeCouponId });
        this.props.actions.removeAdjustmentById(
            this.props.couponData.content.id,
            this.props.couponAnimation,
            selectedCouponCode
        );

        this.props.setApplyCouponRequest(couponListId);
        const [couponAppledNum] = CouponUtilsHelper.getSavedPromoCodeValues();
        // /* istanbul ignore next */
        if (
            !this.props.couponAnimation &&
            couponAppledNum === this.props.couponData.content.promoCode
        )
            CouponUtilsHelper.removePromoCode();
    };

    getChannelName(channelName) {
        switch (channelName.toLowerCase()) {
            /* istanbul ignore next */
            case COUPON_REDEEMING_CHANNEL_ALL:
                return COUPON_CATEGORY_ALL;
            /* istanbul ignore next */
            case COUPON_REDEEMING_CHANNEL_IN_STORE:
                return COUPON_CATEGORY_IN_STORE;
            default:
                /* istanbul ignore next */
                return COUPON_CATEGORY_ONLINE_ONLY;
        }
    }

    /* istanbul ignore next */
    handleCloseModal() {
        document.body.style.overflow = 'scroll';
        document.body.style.position = 'static';
        this.setState({
            showInfoMsg: false,
        });
    }

    showApplyRemoveSucess = (couponApplicationState) => {
        if (couponApplicationState.status && couponApplicationState.status === 204) {
            this.props.onApplyCouponCallBack(couponApplicationState);
            // TODO: Georrge, SOmebody from Coupons team  to correct this condition as
            // this is setState inside render function
            // Not sure why state mutated like this
            // When I changed to setState I got maximum update reached
            this.state.removeCouponId !== couponApplicationState.id &&
                this.setState({ removeCouponId: couponApplicationState.id });
            //  Returns callbackfunction containg name of the applied coupon object {}
        }

        if (couponApplicationState.status && couponApplicationState.status === 201) {
            this.props.onRemoveCouponCallBack(this.props.couponData.content.promoCode);
            //  Returns callbackfunction containg name of the applied coupon name
        }
    };

    renderInfoMsg() {
        return this.state.showInfoMsg ? (
            <CouponAppliedModal
                title={IRIS_COUPON_EMPTYCART_LABEL}
                message={couponErrorMessages.IRIS_COUPON_NO_CART_ITEMS}
                onClose={this.handleCloseModal}
                channel="TOF"
                level={2}
                deviceType={this.props.deviceType}
                errorType={1}
                shopSalesLink={this.props.couponData.content.linkUrl}
            />
        ) : null;
    }

    renderBarcode(data, promoCode) {
        const channelName = this.props.redeemingChannel; // getting channelname
        const couponContent = data.content || {};
        const { linkText, barCodeUrl } = couponContent;
        const ShowBarCodeData = [];
        const Offers = couponContent.offers || [];
        const barCodeData = Offers.reduce((total, value) => {
            if (value.barCode) {
                total.push(value);
            }
            return total;
        }, []);

        if (barCodeData.length) {
            const printCTA = { label: linkText, href: barCodeUrl }; // to get the print button
            ShowBarCodeData.push(
                <ShowBarCode
                    promoCode={promoCode}
                    automationId="code-remove"
                    className={cx('couponShopBtn')}
                    barcodeData={barCodeData}
                    modalAutoId="barCodeModal"
                    channelName={this.getChannelName(channelName)}
                    redeemingChannel={channelName}
                    printOption={printCTA}
                    inlineBarCode={this.props.enableCouponExposeBarcodes}
                    from={this.props.couponAnimation ? 'drawer' : null}
                    enableModelBlockTheme={isIosSafari()}
                    isCouponDrawer={this.props.isCouponDrawer}
                />
            );
            return ShowBarCodeData;
        }
        const shouldHideInDetailsView =
            this.props.deviceType &&
            this.props.deviceType.isMobile &&
            this.props.couponDetailsModal === this.props.couponSlot;
        if (
            this.props.displayCouponType &&
            channelName === COUPON_REDEEMING_CHANNEL_ALL &&
            !shouldHideInDetailsView
        ) {
            return (
                <div className={cx('couponType', 'noCouponNeeded')}>
                    In-store offer. No coupon needed.
                </div>
            );
        }
        return '';
    }

    renderApplyHtml(
        redeemingChannel,
        promoCode,
        id,
        featureFlags,
        bagItemCount,
        linkUrl,
        couponListId
    ) {
        const {
            displayCouponType,
            couponAnimation,
            couponApplicationState: {
                isInlineLoader,
                selectedCouponCode,
                // 001 doAnimation,
                isApplySuccess,
                isRemoveSuccess,
            } = {},
        } = this.props;

        // coupon code exists and not applied, and we're not in "in store only" section (MNPDPYODA-5524)
        // then we should show the red button
        /* istanbul ignore next */
        if (promoCode && (!id || couponAnimation) && redeemingChannel !== 'instore') {
            // if cart is not empty or feature flag disabled - show apply
            if (!featureFlags.Coupon_ShopNowOverApply || bagItemCount > 0) {
                const isClickedCoupon = selectedCouponCode === promoCode; // This flag to run the animation for selected coupon
                const activityMapRegionForApply =
                    bagItemCount <= 0 && featureFlags.Coupon_AllowApplyEmptyCart
                        ? 'Apply-EC'
                        : 'Apply';

                let disableButton = false;
                if (selectedCouponCode && isInlineLoader) {
                    disableButton = !isClickedCoupon; // logic for disabling other buttons
                }

                const applyText = displayCouponType ? (
                    <p>
                        <span className={cx('applyText')}>
                            {couponAnimation && id ? 'remove code:' : 'apply code: '}
                        </span>
                        <span className={cx('couponCode')}> {promoCode}</span>
                    </p>
                ) : (
                    'Apply'
                );

                /* const iconStyle = {
                    opacity: 1,
                    transform: `translateY(-${couponInfoHeight}px)`,
                }; 001 disabled Not working animation code */

                return (
                    <div
                        id={`${activityMapRegionForApply}|${promoCode}`}
                        className={cx('codeApplyBtn')}
                    >
                        <section className={couponAnimation ? cx('codeApplyWrapper') : ''}>
                            <Button
                                type="button"
                                automationId="code-apply"
                                buttonType={id ? 'Secondary' : 'Primary'}
                                className={cx('couponShopBtn', 'removeBtn', {
                                    shrink: isClickedCoupon && isInlineLoader,
                                })}
                                size="Md"
                                isDisabled={disableButton}
                                // eslint-disable-next-line no-confusing-arrow
                                onClick={() =>
                                    id
                                        ? this.onRemoveCoupon(promoCode, couponListId)
                                        : this.onApplyCoupon(featureFlags, promoCode, couponListId)
                                }
                            >
                                {applyText}
                            </Button>
                            {couponAnimation && (
                                <>
                                    <Loader
                                        themeConfig={{
                                            loader: id ? cx('blackLoader') : cx('whiteLoader'),
                                        }}
                                        loaderClass={cx('inlineLoader', [
                                            isClickedCoupon && isInlineLoader ? 'show' : 'hide',
                                        ])}
                                    />
                                    <Icon
                                        iconType="svg"
                                        automationId="apply-coupon-error-icon"
                                        width="96px"
                                        height="96px"
                                        viewBox="0 0 96 96"
                                        // 001 inLineStyle={(isClickedCoupon && doAnimation === true) ? iconStyle : null}
                                        className={cx('icon', {
                                            hide: isRemoveSuccess,
                                            alertHeight: !isApplySuccess,
                                        })}
                                    >
                                        {isApplySuccess ? <SuccessCheck /> : <Alert />}
                                    </Icon>
                                </>
                            )}
                        </section>
                    </div>
                );
            }
            // else show Shop Now
            return (
                <div id={`Shop Now|${promoCode}`} className={cx('codeApplyBtn')}>
                    <Button
                        type="button"
                        data-automation-id="at-coupon-goShop"
                        buttonType="Primary"
                        className={cx('couponShopBtn', 'removeBtn')}
                        size="Md"
                        onClick={() => window.location.assign(linkUrl)}
                    >
                        Shop Now
                    </Button>
                </div>
            );
        }

        // coupon is Applied showing Remove button
        if (id) {
            const removeText = displayCouponType ? (
                <>
                    <span className={cx('applyText')}>remove code: </span>
                    <span className={cx('couponCode')}> {promoCode}</span>
                </>
            ) : (
                'Remove'
            );

            return (
                <div id={`Remove|${promoCode}`} className={cx('codeRemoveBtn')}>
                    <Button
                        type="button"
                        automationId="code-remove"
                        buttonType="Secondary"
                        className={cx('couponShopBtn')}
                        size="Md"
                        onClick={this.onRemoveCoupon}
                    >
                        {removeText}
                    </Button>
                </div>
            );
        }

        return '';
    }

    render() {
        const {
            couponData,
            couponVariant,
            bagItemCount,
            featureFlags,
            couponApplicationState,
            deviceType,
        } = this.props;
        const { id: couponListId } = couponData;
        const couponContent = (couponData && couponData.content) || {};
        const { linkUrl } = couponContent;
        const { promoCode, id, redeemingChannel } = couponContent;
        this.showApplyRemoveSucess(couponApplicationState);
        // // Dynamically adding classes depending on Props
        // const couponAppliedClass = id ? 'couponApplied' : '';
        const couponApplyClass =
            couponVariant === 'Small' ? cx('couponApplyBlockInherit') : cx('couponApplyBlock');
        const isCurrentDetailsModalOpen =
            this.props.couponDetailsModal === this.props.couponSlot && !deviceType.isMobile;

        return (
            <div className={couponApplyClass}>
                {this.renderInfoMsg()}
                <div className={cx('couponCTABtnBlock')}>
                    {/* MPDPYODA-4452 */}
                    {!isCurrentDetailsModalOpen &&
                        this.renderApplyHtml(
                            redeemingChannel,
                            promoCode,
                            id,
                            featureFlags,
                            bagItemCount,
                            linkUrl,
                            couponListId
                        )}
                    {this.renderBarcode(couponData, promoCode)}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    couponApplicationState: state.couponApplicationState,
    bagItemCount: state.bagItemCount,
    deviceType: selectDeviceType(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        Object.assign(adjustmentActions, analyticsActions, CouponDetailsModalAction),
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponApply);
